<template>
	<div>
		<el-form :rules="rules" :model="loginForm" ref="loginFormTable" class="login-container" label-position="left"
		         label-width="0px" v-loading="loading">
		  <h3 class="login_title">系统登录</h3>
		  <el-form-item prop="username">
		    <el-input type="text" v-model="loginForm.username" placeholder="账号" @keyup.enter.native="submitClick('loginFormTable')"></el-input>
		  </el-form-item>
		  <el-form-item prop="password">
		    <el-input type="password" v-model="loginForm.password" placeholder="密码" @keyup.enter.native="submitClick('loginFormTable')"></el-input>
		  </el-form-item>
			<el-form-item>
			  <span style="float: left;">没有账号，去 <el-link type="primary" href="https://www.helloword.com.cn/register" target="_blank" :underline="false">注册</el-link></span>
			  <span style="float: right;"><el-link type="primary" href="https://www.helloword.com.cn/forgot_password" target="_blank" :underline="false">忘记密码</el-link></span>
			</el-form-item>
		  <el-form-item style="width: 100%">
		    <el-button type="primary" @click="submitClick('loginFormTable')" style="width: 100%">登录</el-button>
		  </el-form-item>
		</el-form>
	</div>

</template>
<script>
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
	  rules: {
	    username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
	    password: [{ required: true, message: "请输入密码", trigger: "blur" }]
	  },
      loading: false
    };
  },
  methods: {
    submitClick(formName) {
		this.$refs[formName].validate((valid) => {
		  if (valid) {
			var _this = this;
			this.loading = true;
			this.postRequest("/login", {
			  username: this.loginForm.username,
			  password: this.loginForm.password
			}).then(resp => {
			  _this.loading = false;
			  if (resp && resp.status == 200) {
			    var data = resp.data;
				  if(!data.success){
					  this.$message.error(data.msg);
					  return;
				  }

			    _this.$store.commit("login", data.obj);
			    var path = _this.$route.query.redirect;
			    _this.$router.replace({
			      path: path == "/" || path == undefined ? "/home/index" : path
			    });
			  }
			});
		  } else {
			return false;
		  }
		});
    }
  }


};
</script>


<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 230px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.login_remember {
  margin: 0px 0px 35px 0px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue